var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',[_c('section',{class:_vm.$style.section},[_c('p',{class:_vm.$style.content},[_vm._v(" "+_vm._s(_vm.$t('homescapes.description'))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }